import React from 'react';

import style from './index.module.scss';

const SearchPriceOffersInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Поиск ценовых предложений</h1>
    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>Автоматизировать процесс сбора ценовой информации</div>
        <div className={style.descriptionItem}>Получить актуальные цены от активных поставщиков</div>
        <div className={style.descriptionItem}>Сопоставить всю ценовую информацию в едином реестре</div>
      </div>
    </div>
  </>
);

export default SearchPriceOffersInfo;
